import { render, staticRenderFns } from "./AlarmDispose.vue?vue&type=template&id=33d75560&scoped=true&"
import script from "./AlarmDispose.vue?vue&type=script&lang=js&"
export * from "./AlarmDispose.vue?vue&type=script&lang=js&"
import style0 from "./AlarmDispose.vue?vue&type=style&index=0&id=33d75560&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d75560",
  null
  
)

export default component.exports